 <template>
    <v-card class="flex pa-0 background-2 round-card">
        <v-card-title class="pa-3">
			<p class="pl-2 pl-xl-3">{{ title }}</p>
		    <v-spacer></v-spacer>

			<v-tooltip v-if="!showTable" top>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="showTable = !showTable" icon>
						<v-icon>storage</v-icon>
					</v-btn>
				</template>
		        <span>Visualizza Tabella</span>
		    </v-tooltip>
			<v-tooltip top v-if="!showTable">
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" icon>
						<v-icon>get_app</v-icon>
					</v-btn>
				</template>
		        <span>Download</span>
		    </v-tooltip>
			<v-tooltip v-else top>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="showTable = !showTable" icon>
						<v-icon>equalizer</v-icon>
					</v-btn>
				</template>
		        <span>Visualizza Grafico</span>
		    </v-tooltip>
			<v-tooltip top v-if="showTable">
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="$eventBusUtility.exportCSV(tableHeaders, chartData, 'Prodotti_asset')" icon>
						<v-icon>get_app</v-icon>
					</v-btn>
				</template>
		        <span>Download</span>
		    </v-tooltip>
        </v-card-title>        
        <v-divider></v-divider>

		<v-container fluid class="pt-8 px-2">
            <fields-generator v-if="loaded"
                :fieldsset.sync="fieldsset"
                :model="model"
                ref="fieldsgenerator"
                :selectChange="onChange"
            ></fields-generator>

        	<v-divider></v-divider>
			<v-row v-show="showTable && loaded" class="ma-0">
				<v-data-table 
					class="background-2 w100p"
					:items="chartData"
					:headers="tableHeaders"
					multi-sort
					hide-default-footer
					disable-pagination>
				</v-data-table>
			</v-row>

            <v-row v-show="!showTable && loaded" class="ma-0">
				<v-col id="exportbutton"></v-col>
				<v-col cols="12">
					<column-chart v-if="loadedData"
						:chart-data="chartData" 
					></column-chart>
				</v-col>
			</v-row>

        </v-container>
    </v-card>
</template>

<script>
	import Vue from 'vue'
    import ColumnChart from '@/components/common/ColumnChart'

    export default {
        name: "assetproduct-chart",
        components: {
            ColumnChart,
        },
        props: {
            url: String,
            title: String,
        },

        data() {
            return {
                loaded: false,
                loadedData: false,
                showTable: true,
                fieldsset: {},
                chartData: [],
				model: {
					//[this.modelKey]: this.modelId,
				},
				infoData: {},
				tableHeaders: [
					{
						'text': 'Prodotto',
						'value': 'name',
					},
					{
						'text': 'Quantità',
						'value': 'quantity',
					}
				]
            }
        },

        watch: {
            model: {
                handler() {
                    this.getData()
                },
                deep: true,
                immediate: true,
            },
        },

        created() {
			this.axios.post(this.url + '-info', this.model).then(response => {
				// get body data
				this.infoData = response.data.info
				this.fieldsset = response.data.info

				_.forEach(this.fieldsset, (value, key) => {
				    if(value.default) {
				        Vue.set(this.model, value.key, value.default)
				    }
				})
                this.loaded = true
                
			}, response => {
				// error callback
			})
        },
        
        methods: {
			getData() {
				this.axios.post(this.url, this.model).then(response => {
					this.chartData = response.data.data
					this.loadedData = true

				}, response => {
					// error callback
				})
            },
             
            onChange(field, event) {
				Promise.all(this.$eventBusUtility.fieldsGeneratorConditions(field, event, this.fieldsset, this.model, this.support)).then((responses) => {
                    responses.forEach(response => {
                        if(this.model[response.key]) {
                            this.$refs.fieldsgenerator.$refs[response.key][0].$emit('change', this.model[response.key])
                        }
                    })
                })
            },
        },
    }
</script>

<style>

</style>
